import React from "react";

export default function Hero() {
  return (
    <section className="relative min-h-screen flex flex-col justify-center items-center pt-24 pb-10 px-4 sm:px-6 overflow-hidden">
      {/* Background Ambience (Optional) */}
      <div className="absolute inset-0 flex items-center justify-center opacity-20 pointer-events-none"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto flex flex-col items-center text-center">
        
        {/* --- 1. Badge & Text Content (Compact Layout) --- */}
        <div className="inline-block mb-4 px-3 py-1.5 rounded-full border border-orange-500/30 bg-orange-500/5 backdrop-blur-sm">
          <span className="text-orange-400 text-xs sm:text-sm font-medium tracking-wide">
            EXCLUSIVE PARTNER ACCESS
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-4 tracking-tight text-white leading-tight">
          Streamlined Design
          <span className="block bg-gradient-to-r from-orange-500 via-red-500 to-amber-500 bg-clip-text text-transparent">
            Collaboration.
          </span>
        </h1>

        <p className="text-lg md:text-xl text-gray-400 mb-6 max-w-2xl mx-auto leading-relaxed">
          A centralized hub for submitting requirements, managing proposals, and receiving final design assets.
        </p>

        {/* --- 2. Action Buttons --- */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8 sm:mb-10 w-full">
          <a href="https://partner.designsbydmi.com/login" className="w-full sm:w-auto">
            <button className="w-full sm:w-auto group relative px-8 py-3.5 bg-gradient-to-r from-orange-500 to-red-500 rounded-lg font-semibold text-base sm:text-lg overflow-hidden transition-all duration-300 hover:shadow-lg hover:shadow-orange-500/50 cursor-pointer text-white">
              <span className="relative z-10">Partner Login</span>
              <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
          </a>

          <a href="https://partner.designsbydmi.com/register" className="w-full sm:w-auto">
            <button className="w-full sm:w-auto px-8 py-3.5 border border-gray-700 rounded-lg font-semibold text-base sm:text-lg hover:border-orange-500/50 hover:bg-orange-500/5 transition-all duration-300 backdrop-blur-sm cursor-pointer text-white">
              Become a Partner
            </button>
          </a>
        </div>

        {/* --- 3. Cinematic Video (Integrated View) --- */}
        <div className="relative w-full max-w-4xl mx-auto mt-2">
          {/* Glassmorphism Frame */}
          <div className="relative group rounded-xl p-1 bg-gradient-to-b from-white/10 to-white/5 backdrop-blur-sm border border-white/10 shadow-2xl shadow-orange-900/20">
            
            {/* Video Player */}
            <div className="relative rounded-lg overflow-hidden aspect-video bg-black/50">
              <video 
                className="w-full h-full object-cover"
                src="https://partner.designsbydmi.com/dmi_partner_portal.mp4"
                autoPlay
                loop
                muted
                playsInline
                controls
              />
              {/* Inner Shadow Overlay */}
              <div className="absolute inset-0 pointer-events-none shadow-[inset_0_0_50px_rgba(0,0,0,0.5)]"></div>
            </div>

            {/* Backlight Glow */}
            <div className="absolute -inset-1 bg-gradient-to-r from-orange-500 to-red-600 rounded-xl blur-xl opacity-20 group-hover:opacity-30 transition duration-1000 -z-10"></div>
          </div>
        </div>

      </div>
    </section>
  );
}